import React from "react";
import MomentUtils from "@date-io/moment";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";

const CustomDatePicker = ({
  appLang,

  label,
  value,
  minDate,
  maxDate,
  required,
  fullWidth,
  clearable,
  error,
  helperText,
  onChange,

  openTo = "day",
  views = ["year", "month", "day"],
  format = "L",
  inputVariant = undefined,
  sx = undefined
}) => {
  const {t} = useTranslation();

  return (
    <LocalizationProvider utils={MomentUtils} adapterLocale={appLang} dateAdapter={AdapterMoment}>
      <DatePicker
        slotProps={{
          textField: {
            helperText: helperText,
            label: label,
            variant: inputVariant,
            sx: sx,
            error: error || false,
            required: required,
            fullWidth: fullWidth,
            clearable: clearable
          }
        }}
        value={value ? moment(value) : null}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
        openTo={openTo}
        views={views}
        format={format}
        cancelLabel={t("components.customDatePicker.cancelLabel")}
        clearLabel={t("components.customDatePicker.clearLabel")}
        okLabel={t("components.customDatePicker.okLabel")}
        todayLabel={t("components.customDatePicker.todayLabel")}
      />
    </LocalizationProvider>
  );
};

export default connect(state => ({
  appLang: state.app.language
}))(CustomDatePicker);
